import React, { useState } from "react";
import { Alert, Autocomplete, Backdrop, CircularProgress, Snackbar, TextField } from "@mui/material";
import { postGiftCardReporte, postReporteCaja, postReportePaseoPlus } from "../../../../../api/ApiService";
import { Download, FileSpreadsheet } from "lucide-react";
import { useSelector } from "react-redux";



function ReportePaseoPlus({
    dataPromociones,
    statusOptionsPaseoPlus,
    tipoReportePaseo, setTipoReportePaseo,
    promocionesData, loadingPromociones, promocionSelected, setPromocionSelected,
    buscarPromocion, setBuscarPromocion,

    localesData, loadingLocales, localSelected, setLocalSelected,
    buscarLocal, setBuscarLocal,
}) {
    const stateToken = useSelector((state) => state.reducerGlobal.token);

    const [loadingCargar, setLoadingCargar] = useState(false);

    const [reportePath, setReportePath] = useState("");
    const [reporteUrl, setReporteUrl] = useState("");

    


    //estado alert
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');


    // console.log("tipoReportePaseo==>", tipoReportePaseo);

    const inputBaseClass = "w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2 text-sm text-gray-700 outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200";

    const autocompleteInputSx = {
        '& .MuiOutlinedInput-root': {
            backgroundColor: '#f1f5f9',
            borderRadius: '0.5rem',
            fontSize: '0.875rem',
        },
    };
    // console.log("localSelected==>", localSelected);


    const handleGenerarReporte = () => {
        if (!tipoReportePaseo || !promocionSelected) {
            // alert("Debes seleccionar tipo de reporte, fecha desde y fecha hasta.");
            setSeverity('error');
            setMensaje("Debes seleccionar tipo de reporte, promoción.");
            setOpen(true);
            return;
        }
        //cuando se selecciona el local: aplica solo al reporte de canjes
        if (tipoReportePaseo === "Reporte de Canjes" && !localSelected) {
            setSeverity('error');
            setMensaje("Debes seleccionar un local para el reporte de canjes.");
            setOpen(true);
            return;
        }

        const body = {
            tipo_de_reporte: tipoReportePaseo,
            local_id: localSelected?.id,
            promocion_vale_id: promocionSelected?.id || null,
        };
        // console.log("body==>", body);



        setLoadingCargar(true);
        setReportePath("");
        setReporteUrl("");

        postReportePaseoPlus(stateToken?.access_token, body)
            .then((response) => {
                // console.log("response==>postReportePaseoPlus", response);
                setReportePath(response?.path || "");
                setReporteUrl(response?.url || "");
            })
            .catch((error) => {
                console.log("error==>postReportePaseoPlus", error);
                alert("No se pudo generar el reporte. Intenta nuevamente.");
            })
            .finally(() => {
                setLoadingCargar(false);
            });



        // if (tipoReportePaseo === "Reporte Caja") {

        //     const bodyCaja = {
        //         fecha_desde: fechaDesde,
        //         fecha_hasta: fechaHasta,
        //     };
        //     // console.log("bodyCaja==>", body);

        //     postReportePaseoPlus(stateToken?.access_token, bodyCaja)
        //         .then((response) => {
        //             // console.log("response==>postReportePaseoPlus", response);
        //             setReportePath(response?.data?.path || "");
        //             setReporteUrl(response?.data?.url || "");
        //         })
        //         .catch((error) => {
        //             console.log("error==>postReportePaseoPlus", error);
        //             alert("No se pudo generar el reporte. Intenta nuevamente.");
        //         })
        //         .finally(() => {
        //             setLoadingCargar(false);
        //         });
        // } else {

        //     // console.log("postGiftCardReporte==>", body);

        //     postGiftCardReporte(stateToken?.access_token, body)
        //         .then((response) => {
        //             // console.log("response==>postGiftCardReporte", response);
        //             setReportePath(response?.path || "");
        //             setReporteUrl(response?.url || "");
        //         })
        //         .catch((error) => {
        //             console.log("error==>postGiftCardReporte", error);
        //             alert("No se pudo generar el reporte. Intenta nuevamente.");
        //         })
        //         .finally(() => {
        //             setLoadingCargar(false);
        //         });
        // }
    };

    const handleDescargarXlsx = () => {
        if (!reporteUrl) {
            alert("Primero debes generar el reporte.");
            return;
        }

        const fileNameFromPath = reporteUrl?.split("/")?.pop() || "reporte_giftcard.xlsx";

        let rUrl = reporteUrl;
        if (window.location.protocol === 'https:' && rUrl.startsWith('http://')) {
            rUrl = rUrl.replace('http://', 'https://');
        }

        const link = document.createElement("a");
        link.href = rUrl;
        link.setAttribute("download", fileNameFromPath);
        link.setAttribute("target", "_blank");
        link.rel = "noopener noreferrer";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    const handleClose = () => {
        setOpen(false);
    };



    return (
        <div className="bg-gray-100 mb-6">
            <div className="mx-auto max-w-7xl">
                <div className="rounded-xl border border-gray-200 bg-white p-4 md:p-6">
                    <div className="mb-5 flex items-center gap-3">
                        <div className="rounded-xl bg-emerald-50 p-2.5">
                            <FileSpreadsheet className="h-5 w-5 text-emerald-600" />
                        </div>
                        <div>
                            <h2 className="text-xl font-bold text-gray-800">Reportes Paseo Plus</h2>
                            <p className="text-sm text-gray-500">Selecciona filtros para generar y descargar el XLSX</p>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                        <div>
                            <label className="mb-1.5 block text-sm font-semibold text-gray-700">Tipo de reporte</label>
                            <select
                                value={tipoReportePaseo}
                                onChange={(e) => setTipoReportePaseo(e.target.value)}
                                className={inputBaseClass}
                            >
                                {statusOptionsPaseoPlus.map((option) => (
                                    <option key={option.id} value={option.nombre}>
                                        {option?.nombre}
                                    </option>
                                ))}
                            </select>
                        </div>


                        <div>
                            <label className="mb-1.5 block text-sm font-semibold text-gray-700">
                                Seleccionar una Promoción
                            </label>
                            <Autocomplete
                                disablePortal
                                options={dataPromociones}
                                sx={{ width: '100%' }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Seleccione"
                                        size="small"
                                        sx={autocompleteInputSx}
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <React.Fragment>
                                                    {loadingPromociones ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </React.Fragment>
                                            ),
                                        }}
                                    />
                                )}
                                // onInputChange={(event, newInputValue, reason) => {
                                //     // if (reason === 'input') handleSorteoSearch(newInputValue);
                                //     if (reason === 'input') {
                                //         setBuscarPromocion(newInputValue);
                                //     }

                                //     //capturar cambio cuando se borra el input (clear)
                                //     if (reason === 'clear') {
                                //         setBuscarPromocion("");
                                //     }
                                // }}
                                // onChange={(e, value) => handleSorteoSelected(value)}
                                onChange={(e, value) => {
                                    setPromocionSelected(value);
                                }}
                                value={promocionSelected}
                                getOptionLabel={(option) => option?.nombre}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderOption={(props, option) => (
                                    <li
                                        {...props}
                                        key={option.id}
                                        className="flex items-center justify-between gap-3 rounded-md px-3 py-2 transition-colors hover:bg-slate-100"
                                    >
                                        <span className="truncate text-sm font-medium text-slate-800">
                                            {option?.nombre}
                                        </span>
                                    </li>
                                )}
                                loadingText="Cargando..."
                                loading={loadingPromociones}
                                noOptionsText="No hay opciones"
                            />
                        </div>

                        <div>
                            <label className="mb-1.5 block text-sm font-semibold text-gray-700">
                                Local (opcional, aplica solo al reporte de canjes)
                            </label>
                            <Autocomplete
                                disablePortal
                                options={localesData}
                                sx={{ width: '100%' }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Seleccione"
                                        size="small"
                                        sx={autocompleteInputSx}
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <React.Fragment>
                                                    {loadingLocales ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </React.Fragment>
                                            ),
                                        }}
                                    />
                                )}
                                // onInputChange={(event, newInputValue, reason) => {
                                //     // if (reason === 'input') handleSorteoSearch(newInputValue);
                                //     if (reason === 'input') {
                                //         setBuscarLocal(newInputValue);
                                //     }

                                //     //capturar cambio cuando se borra el input (clear)
                                //     if (reason === 'clear') {
                                //         setBuscarLocal("");
                                //     }
                                // }}
                                // onChange={(e, value) => handleSorteoSelected(value)}
                                onChange={(e, value) => {
                                    setLocalSelected(value);
                                }}
                                value={localSelected}
                                getOptionLabel={(option) => {
                                    if (option?.nombre) return option.nombre;
                                    if (option?.nombre_fantasia) return option?.nombre_fantasia + " - " + (option?.ruc || "Sin RUC");
                                    return "";
                                }}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderOption={(props, option) => (
                                    <li
                                        {...props}
                                        key={option.id}
                                        className="flex items-center justify-between gap-3 rounded-md px-3 py-2 transition-colors hover:bg-slate-100"
                                    >
                                        <span className="truncate text-sm font-medium text-slate-800">
                                            {option?.nombre || `${option?.nombre_fantasia || ""}${option?.ruc ? ` - RUC: ${option.ruc}` : ""}`}
                                        </span>
                                    </li>
                                )}
                                loadingText="Cargando..."
                                loading={loadingLocales}
                                noOptionsText="No hay opciones"
                            />
                        </div>
                    </div>

                    <div className="mt-6 flex flex-col gap-3 md:flex-row">
                        <button
                            type="button"
                            onClick={handleGenerarReporte}
                            className="inline-flex items-center justify-center rounded-lg bg-[#104063] px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-[#0d3553]"
                        >
                            Generar reporte
                        </button>

                        <button
                            type="button"
                            onClick={handleDescargarXlsx}
                            disabled={!reporteUrl}
                            className="inline-flex items-center justify-center gap-2 rounded-lg bg-emerald-600 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-emerald-700 disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            <Download className="h-4 w-4" />
                            Descargar XLSX
                        </button>
                    </div>

                    {reporteUrl && (
                        <div className="mt-4 rounded-lg border border-emerald-100 bg-emerald-50 px-4 py-3 text-sm text-emerald-800">
                            Reporte generado correctamente. Ya puedes descargar el archivo.
                        </div>
                    )}
                </div>
            </div>


            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>

            <Backdrop open={loadingCargar} sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
}

export default ReportePaseoPlus;